import moment, { Moment } from 'moment';
import { MouseEventHandler } from 'react';

import { SearchTermsType } from '../models/SearchTermsType';
import * as Yup from 'yup';
import { EXTRACTED, BARCODE, BARCODE_READ, MIN_CUSTOMER_NAME_LENGTH } from '../constants';
import { Phone } from '../models/customerOverview';
import { PhoneType } from './types';
import { TABLE_HEADER_B2B_REPORTREADY, TABLE_HEADER_B2B_REPORTREJECTED, TABLE_HEADER_TASSCARE } from '../styles/styled-components/Customer/Customer';

export function toMoment(date: string) {
  return moment(date, 'YYYY-MM-DDTHH:mm:SSSZ');
}

export function toLocalTime(date: string | Moment, format: 'd' | 'm' | 't' = 't') {
  const mdate = (date as string).length ? moment(date, 'YYYY-MM-DDTHH:mm:SSSZ') : date as Moment;
  switch (format) {
    case 'm':
      return mdate.format('YYYY-MM');
    case 'd':
      return mdate.format('YYYY-MM-DD');
    case 't':
      return mdate.format('YYYY-MM-DD HH:mm');
  }
}
export const isExtracted = (term: string) => term && term.match(EXTRACTED);

export function getInput(term: string): SearchTermsType {
  term = term.trim();
  const result: SearchTermsType = {};
  const isValidEmail = Yup.string().email().isValidSync(term);
  if (!term) {
    return result;
  } else if (term.match(BARCODE)) {
    result.barcode = term;
  } else if (term.match(BARCODE_READ)) {
    result.barcode = term.replace(/-/g, '');
  } else if (isValidEmail) {
    result.email = term;
  } else if (term.length >= MIN_CUSTOMER_NAME_LENGTH) {
    result.name = term;
  }
  return result;
}

export function onEvent<T>(check: (v: React.MouseEvent<T, MouseEvent>) => boolean, run: (v: React.MouseEvent<T, MouseEvent>) => void, message?: string): MouseEventHandler<T> {
  return event => {
    // eslint-disable-next-line no-restricted-globals
    if (check(event) && confirm(message || `Update?`)) {
      run(event);
    }
  };
}

export function getQueryStringParam(paramName: string): string | undefined {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName) || undefined;
}

export const byDatetime = (a: { datetime: string }, b: { datetime: string }) =>
  moment(b.datetime).valueOf() - moment(a.datetime).valueOf();

export const isNotUndefined = <T>(thing: T | undefined): thing is T => thing !== undefined;

export function not<X>(f: (x: X) => boolean): (x: X) => boolean {
  return x => !f(x);
}

export function getUrlParams(): URLSearchParams {
  return new URLSearchParams(window.location.search);
}

export function getPhoneNumber(phones: Phone[], type: PhoneType = PhoneType.MOBILE) {
  if (phones.length) {
    phones.sort(byDatetime);
  }
  const phone = (phones || []).filter(i => i.name.startsWith(type))[0];
  return phone ? { countryCode: phone.countryCode, phoneNo: phone.number } : { countryCode: '-', phoneNo: '-' };
}
export const stripHypen = (str: string) => str.replace(/-/g, '');
export function getHeader(filter: string) {
  switch (filter) {
    case 'report-ready':
      return TABLE_HEADER_B2B_REPORTREADY;
    case 'rejected':
      return TABLE_HEADER_B2B_REPORTREJECTED;
  }
  return TABLE_HEADER_TASSCARE;
}

const MOBILE_PHONE_REGEX = /^[1-9]{1}[0-9]{3,14}$/;
export function isValidMobilePhone(value: string): boolean {
  return Boolean(value) && (value === '-' || MOBILE_PHONE_REGEX.test(value));
}
